export default {
  name: "语言",
  selection: "系统语言选择",
  english: "English",
  simplified_chinese: "中文（简体）",
  traditional_chinese: "中文（繁体）",
  vietnamese: "Tiếng Việt",
  thai: "ไทย",
  indonesian: "Bahasa Indonesia",
  malay: "Melayu",
  japanese: "日本",
  korean: "한국어",
  combodia: "កម្ពុជា",
  native: {
    english: "英文",
    simplified_chinese: "中文 （简体）",
    traditional_chinese: "中文 （繁体）",
    vietnamese: "越南文",
    thai: "泰文",
    indonesian: "印度尼西亚文",
    malay: "马来文",
    japanese: "日文",
    korean: "韩文"
  }
};
